import { defineComponent as _defineComponent } from 'vue'
export interface Props {
  value: string;
  statusConfigs?: StatusConfig;
  fullwidth?: boolean;
}


import { computed } from 'vue';
import LabelStatus from '@components/LabelStatus.vue';
import type { StatusConfig } from '@components/LabelStatus.vue';

declare module '@vue/runtime-core' {
  export interface GlobalComponents {
    TableCellStatus: ComponentWithProps<Props>;
  }
}

const __default__ = { name: 'TableCellStatus' };

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
    value: null,
    statusConfigs: null,
    fullwidth: { type: Boolean, default: false }
  },
  setup(__props: any) {

const props = __props as { value: string, statusConfigs?: StatusConfig, fullwidth: boolean };



const status = computed(() => props.value);

return { __sfc: true,props, status, LabelStatus }
}

})